var _rect, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeeklyForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 22,
    viewBox: "0 0 49 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 47.75,
    height: 22,
    rx: 3,
    fill: "#21908C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9078 15L9.19084 7.245H10.3788L12.6338 13.944H12.2268L14.6138 7.245H15.4828L17.7268 13.944H17.3528L19.6848 7.245H20.8068L18.0678 15H17.0888L14.9108 8.62H15.1418L12.8758 15H11.9078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 9.66819H35.4472L37.3881 7.67055C35.4543 5.75792 32.3232 5.68708 30.3893 7.59971C28.4555 9.51943 28.4555 12.6151 30.3893 14.5348C32.3232 16.4545 35.4543 16.4545 37.3881 14.5348C38.3515 13.5855 38.8332 12.4734 38.8332 11.0708H40.25C40.25 12.4734 39.6266 14.2939 38.3799 15.5265C35.8935 17.9917 31.8557 17.9917 29.3693 15.5265C26.8899 13.0684 26.8687 9.07315 29.3551 6.61506C31.8415 4.15698 35.8297 4.15698 38.3161 6.61506L40.25 4.62451V9.66819ZM34.2288 8.16642V11.177L36.7081 12.6505L36.1981 13.5076L33.1662 11.7083V8.16642H34.2288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyForecast);
export default __webpack_public_path__ + "static/media/weeklyForecast.1950d1c0f990dbf55641ae297d6bf7fe.svg";
export { ForwardRef as ReactComponent };